module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAKCAYAAABSfLWiAAAAkElEQVQokZXMsQ2DQAyF4Z/MQEebhkjsQEtLwzpZJwsgFFDEDrQUNLTMEDky0mFxx8XNk+2nL6mfLYEpgBfQAJOvdrsAPkCuWfyL7ECqexqCzhAXWIFK0wtZ5GGAEug0XSj3IXfgbYBZf7OBeu0fEDmMQHYC7ONC0pP+DxIkBghCggyRgA8aBNmAJRKw0AJsXx3dLg56tlQEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/go_up.png
// module id = 0SGq
// module chunks = 1